export const isChildPage = (pathname: string): boolean => {
  return pathname.split("/").length > 3
}

export const isCorporatePage = (pathname: string): boolean => {
  const [_empty, _locale, featureName] = pathname.split("/")

  return featureName === "corporate"
}
